export { default as UA } from './ua';
import UA from './ua';
import { IS_DOUBANAPP, IS_MINIPROGRAM, IS_TALION } from './Globals';
export { obj2str, str2obj, getType, namespace } from '@douban/rexxar-web';
import { callUri as _callUri } from '@douban/rexxar-web';
import { ACCOUNTS_DOMAIN, FRODO_SCHEMA, REXXAR_WEBVIEW_DOMAIN, TALION_DOMAIN } from './consts';
import { setQuery } from './uri';
export function callUri(uri, container) {
    if (UA.isFrodo() || UA.isFrodoMovie()) {
        _callUri(uri, container);
    }
}
/**
 * Turn seconds to minutes:
 *
 * sec2min(61) => '1:01'
 *
 * @param {number} time
 * @returns {string}
 */
export function sec2min(time) {
    var min = ~~(time / 60);
    var sec = time % 60 | 0;
    return "".concat(min, ":").concat(sec < 10 ? '0' : '').concat(sec);
}
export function str2date(ts) {
    if (typeof ts !== 'string') {
        console.error(new TypeError('Invalid Date input:' + ts), ts); // eslint-disable-line
        return new Date();
    }
    return new Date(ts.replace(/\s+/g, 'T').concat('+08:00'));
}
/**
 * Format the timestamp or local time string to humanistic time format:
 *
 * formatTime(1453190264.781) => '10秒前'
 * formatTime('2016-01-19 15:27:31') => '3分钟前'
 *
 * @param {number|string} ts
 * @returns {string}
 */
export function formatTime(ts) {
    if (typeof ts === 'string') {
        var _ts = ts;
        ts = str2date(ts).getTime() / 1000;
        if (isNaN(ts)) {
            return _ts;
        }
    }
    var now = new Date();
    var currentTs = Math.floor(now.getTime() / 1000);
    var dts = currentTs - ts;
    var isFuture = dts < 0;
    dts = Math.abs(dts);
    var dDays = Math.floor(dts / 86400);
    var dHours = Math.floor(dts / 3600);
    var dMinutes = Math.floor(dts / 60);
    if (isFuture) {
        var date = new Date(ts * 1000);
        var todayRemain = (new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime() - now.getTime()) /
            1000;
        var dDays_1 = Math.floor((dts + 86400 - todayRemain) / 86400);
        var time = "".concat(('0' + date.getHours()).slice(-2), ":").concat(('0' + date.getMinutes()).slice(-2));
        if (dDays_1 === 1) {
            return "\u660E\u5929 ".concat(time);
        }
        else if (dDays_1 === 2) {
            return "\u540E\u5929 ".concat(time);
        }
        else if (dDays_1 > 0 && dDays_1 < 4) {
            return "".concat(dDays_1, "\u5929\u540E ").concat(time);
        }
        else if (dDays_1 <= 0 && dHours > 0) {
            return "\u4ECA\u5929 ".concat(time);
        }
        else if (dHours <= 0 && dMinutes > 0) {
            return "".concat(dMinutes, "\u5206\u949F\u540E");
        }
        else if (dMinutes <= 0) {
            return "".concat(dts, "\u79D2\u540E");
        }
        else {
            var year = date.getFullYear();
            var yearStr = '';
            if (year !== now.getFullYear()) {
                yearStr = "".concat(year, "\u5E74");
            }
            return "".concat(yearStr).concat(date.getMonth() + 1, "\u6708").concat(date.getDate(), "\u65E5 ").concat(time);
        }
    }
    if (dDays > 0 && dDays < 4) {
        return "".concat(dDays, "\u5929\u524D");
    }
    else if (dDays <= 0 && dHours > 0) {
        return "".concat(dHours, "\u5C0F\u65F6\u524D");
    }
    else if (dHours <= 0 && dMinutes > 0) {
        return "".concat(dMinutes, "\u5206\u949F\u524D");
    }
    else if (dMinutes <= 0) {
        return '刚刚';
    }
    else {
        var s = new Date(ts * 1000);
        var year = s.getFullYear();
        var yearStr = '';
        if (year !== now.getFullYear()) {
            yearStr = "".concat(year, "\u5E74");
        }
        return "".concat(yearStr).concat(s.getMonth() + 1, "\u6708").concat(s.getDate(), "\u65E5");
    }
}
/**
 * Compare two version strings:
 *
 * vCompare('4.4', '4.5') => -1
 * vCompare('4.4', '4.4.0') => 0
 * vCompare('4.4', '4.12') => 1
 *
 * @param {string} v1
 * @param {string} v2
 * @returns {number} result 1|-1|0
 */
export function vCompare(v1, v2) {
    var v1Parts = v1.split('.'), v2Parts = v2.split('.');
    while (v1Parts.length < v2Parts.length) {
        v1Parts.push('0');
    }
    while (v2Parts.length < v1Parts.length) {
        v2Parts.push('0');
    }
    for (var i = 0; i < v1Parts.length; i++) {
        if (parseInt(v1Parts[i]) === parseInt(v2Parts[i])) {
            continue;
        }
        else if (parseInt(v1Parts[i]) > parseInt(v2Parts[i])) {
            return 1;
        }
        else if (parseInt(v1Parts[i]) < parseInt(v2Parts[i])) {
            return -1;
        }
        else {
            throw new Error('Oops...Unbelievable error! We can only compare numerically!');
        }
    }
    return 0;
}
/**
 * Escape html string
 * From [mustache](https://github.com/janl/mustache.js/blob/master/mustache.js#L60)
 *
 * <script></script> => &lt;script&gt;&lt;&#x2F;script&gt;
 *
 * @param {string} string
 * @returns {string}
 */
export function escapeHtml(string) {
    var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
    };
    return String(string).replace(/[&<>"']/g, function (s) { return entityMap[s]; });
}
/**
 * transform hex color to rgba
 *
 * @param {string} hex "#fff"
 * @param {string|number} addAlpha 0.5
 * @returns {string} "rgba(255,255,255,0.5)"
 */
export function hex2rgb(hex, addAlpha) {
    if (addAlpha === void 0) { addAlpha = 1; }
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    var rgba = {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
    };
    var alpha = ",".concat(addAlpha);
    return "rgba(".concat(rgba.r, ",").concat(rgba.g, ",").concat(rgba.b).concat(alpha, ")");
}
/**
 * truncate string with length (include `...`)
 *
 * @param {string} str "1234567"
 * @param {number} length 5
 * @returns {string} "1234..."
 */
export function truncateString(str, length) {
    if (!str) {
        return '';
    }
    if (str.length <= length) {
        return str;
    }
    return str.substring(0, length - 1) + '...';
}
/**
 * limit the decimal places:
 *
 * 100 -> 99+
 *
 * @param {number} number
 * @param {number} max
 * @returns {string} "99+"
 */
export function shrinkCount(number, max, type) {
    var res;
    if (type === 'k' && max >= 1000) {
        var str = String(number);
        res = number < max ? "".concat(number) : "".concat(str.slice(0, str.length - 3), "k");
    }
    else {
        res = number < max ? "".concat(number) : "".concat(max - 1, "+");
    }
    return res;
}
/**
 * pass false to disable page scrolling
 *
 * @param {boolean}
 */
export function enablePageScroll(bool) {
    document.ontouchmove = bool
        ? function (f) { return f; }
        : function (e) {
            e.preventDefault();
        };
}
export function openShareWidget(shareData) {
    if (!/rexxar/i.test(navigator.userAgent)) {
        callUri("".concat(REXXAR_WEBVIEW_DOMAIN, "/action/share?share_data=").concat(encodeURIComponent(JSON.stringify(shareData))));
    }
    else {
        callUri("douban://douban.com/widget/share?share_data=".concat(encodeURIComponent(JSON.stringify(shareData))));
    }
}
export var ImageShare = {
    makeData: function (_a) {
        var imgData = _a.imgData, _b = _a.url, url = _b === void 0 ? "".concat(TALION_DOMAIN, "/time/") : _b, _c = _a.platforms, platforms = _c === void 0 ? [
            'douban_broadcast',
            'wechat_friends',
            'wechat_moments',
            'weibo',
            'mobile_qq',
            'qzone',
            'chat',
        ] : _c, _d = _a.title, title = _d === void 0 ? '' : _d;
        return encodeURIComponent(JSON.stringify({
            share_object_image_data: imgData,
            platforms: platforms.map(function (platform) {
                return { platform: platform, url: url, title: title };
            }),
        }));
    },
    _isSharing: false,
    share: function (data) {
        var frdVersion = require('./version').frdVersion;
        var Toast = require('../../widget/Toast').default;
        if (ImageShare._isSharing) {
            return;
        }
        ImageShare._isSharing = true;
        if (!frdVersion.since('6.10')) {
            new Toast('error', '请您升级App版本，发现更多精彩').work();
            return;
        }
        if (typeof data !== 'string') {
            data = ImageShare.makeData(data);
        }
        try {
            callUri("".concat(FRODO_SCHEMA, "/widget/share?share_data=").concat(data));
        }
        finally {
            setTimeout(function () {
                ImageShare._isSharing = false;
            }, 1000);
        }
    },
};
/**
 * 字符串插值工具函数
 * format('aa${ key }bb', { key: 'cc' }) => 'aaccbb'
 * @param {string} template 模版字符串, 'aaa${key}bbbb'
 * @param {object} params 数据 { key: 'str' }
 */
export function format(template, params) {
    return template.replace(/\$\{(\s*\w+\s*)\}/g, function (_, key) { return params[key.replace(/(^\s+)|(\s+$)/g, '')] || ''; });
}
export function makeScrollToggle(_a) {
    var _b = _a.threshold, threshold = _b === void 0 ? 50 : _b, _c = _a.startHold, startHold = _c === void 0 ? 0 : _c, _d = _a.endHold, endHold = _d === void 0 ? Infinity : _d, 
    /** onScrollDown(e): trigger scroll  boolean | void 返回 true 忽略处理 */
    onScrollDown = _a.onScrollDown, 
    /** onScrollUp(e): boolean | void 返回 true 忽略处理 */
    onScrollUp = _a.onScrollUp, onScroll = _a.onScroll, 
    /** onToggle(isDown) */
    onToggle = _a.onToggle;
    var scrollTop = window.scrollY;
    var lastIsDown = null;
    var handler = function (e) {
        var _threshold = typeof threshold === 'function' ? threshold() : threshold;
        if (window.scrollY < startHold - _threshold || window.scrollY > endHold + _threshold) {
            return;
        }
        var delta = window.scrollY - scrollTop;
        if (Math.abs(delta) > _threshold) {
            var ignored = false;
            var scrollDown = delta > 0;
            if (scrollDown) {
                if (lastIsDown !== true) {
                    if (onScrollDown) {
                        ignored = onScrollDown(e) || ignored;
                    }
                    if (onToggle) {
                        ignored = onToggle(true) || ignored;
                    }
                }
            }
            else {
                if (lastIsDown !== false) {
                    if (onScrollUp) {
                        ignored = onScrollUp(e) || ignored;
                    }
                    if (onToggle) {
                        ignored = onToggle(false) || ignored;
                    }
                }
            }
            if (!ignored) {
                lastIsDown = scrollDown;
            }
            scrollTop = window.scrollY;
        }
        onScroll && onScroll(e, delta);
    };
    window.addEventListener('scroll', handler);
    window.addEventListener('gesturechange', handler);
    return {
        dispose: function () {
            window.removeEventListener('scroll', handler);
            window.removeEventListener('gesturechange', handler);
        },
    };
}
/**
 * 123456789 => 123,456,789
 */
export function splitNumber(number, step) {
    if (step === void 0) { step = 3; }
    return (number + '')
        .split('')
        .reverse()
        .map(function (v, i) { return (i !== 0 && (i + 1) % step === 0 ? ',' : '') + v; })
        .reverse()
        .join('')
        .replace(/^,/, '');
}
export function repeat(nums, cb) {
    var res = [];
    for (var i = 0; i < nums; i++) {
        res.push(cb(i));
    }
    return res;
}
/**
 * shuffle list
 * @param {[]} array
 */
export function shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
    return array;
}
export function switchLink(uri, url) {
    if (IS_DOUBANAPP) {
        return uri;
    }
    return url;
}
/**
 * onClick={handleMiniProgram.bind(this, `pages/user/user?id=${user.id}`)}
 */
export function handleMiniProgram(url, e) {
    console.log(url);
    if (IS_MINIPROGRAM) {
        e.preventDefault();
        if (url && window['wx']) {
            window['wx'].miniProgram.navigateTo({
                url: url,
            });
        }
    }
}
export function goToLogin() {
    var frdVersion = require('./version').frdVersion;
    var Toast = require('../../widget/Toast').default;
    if (IS_TALION) {
        var currentUrl = window.location.href;
        window.location.href = setQuery(ACCOUNTS_DOMAIN, {
            source: 'mobile',
            redir: encodeURIComponent(currentUrl),
        });
    }
    else if (frdVersion.since('4.9')) {
        callUri("".concat(FRODO_SCHEMA, "/accounts/login"));
    }
    else {
        var toast = new Toast('error', '你还没有登录，请先登录:)');
        toast.work();
    }
}
export function urisafeAtou(s) {
    return decodeURIComponent(atob(s.replace(/\_/g, '+').replace(/\-/g, '/').replace(/\~/g, '=')));
}
export function urisafeUtoa(s) {
    return btoa(encodeURIComponent(s)).replace(/\+/g, '_').replace(/\//g, '-').replace(/\=/g, '~');
}
// https://github.com/visionmedia/debug/blob/78ae6c94122a5c23263b6ea6def0d7ead474fc66/src/debug.js#L44
export function hash(str) {
    if (typeof str !== 'string') {
        throw new TypeError("invalid string input: ".concat(str));
    }
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}
/**
 * 报告报错，
 * @param error
 */
export function reportError(error, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.logOnly, logOnly = _c === void 0 ? false : _c, _d = _b.uri, uri = _d === void 0 ? '' : _d;
    dispatchEvent('rexxar:error', { error: error, logOnly: logOnly, uri: uri });
}
export function sleep(ms) {
    return new Promise(function (res) { return setTimeout(res, ms); });
}
export function dispatchEvent(name, data) {
    var event;
    if ('CustomEvent' in window) {
        event = new CustomEvent(name, { detail: data });
    }
    else {
        event = document.createEvent('Event');
        event.initEvent(name, true, true);
        event['detail'] = data;
    }
    document.dispatchEvent(event);
}
export function onEvent(name, cb) {
    document.addEventListener(name, function (evt) {
        cb(evt['detail']);
    });
}
/**
 * 模拟点击跳转页面
 * @param url
 */
export function goTo(url) {
    var a = document.createElement('a');
    a.href = url;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
        document.body.removeChild(a);
    }, 100);
}
/**
 * 检查 webp 支持
 */
// check_webp_feature:
export var WebpFeatures = {
    lossy: 'lossy',
    lossless: 'lossless',
    alpha: 'alpha',
    animation: 'animation',
};
export var WebpTestCases = {
    lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
    lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
    alpha: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
    animation: 'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
};
export function checkWebpFeature(feature, callback) {
    if (feature === void 0) { feature = 'lossy'; }
    var img = new Image();
    img.onload = function () {
        var result = img.width > 0 && img.height > 0;
        callback(feature, result);
    };
    img.onerror = function () {
        callback(feature, false);
    };
    img.src = 'data:image/webp;base64,' + WebpTestCases[feature];
}
// promise 形式，仅返回查询结果
export function detectWebp(feature) {
    if (feature === void 0) { feature = 'lossy'; }
    return new Promise(function (resolve) {
        checkWebpFeature(feature, function (feature, support) {
            resolve(support);
        });
    });
}
//# sourceMappingURL=utils.js.map